var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBlogFilled = function SvgBlogFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 21h12a4 4 0 0 0 4-4V5a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v13c0 1.657-.343 3-2 3Z",
    fill: "#2955DE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 10a1 1 0 0 1 1-1h1v9.5c0 .56-.128.954-.293 1.181C5.574 19.865 5.38 20 5 20c-.38 0-.574-.135-.707-.319C4.128 19.454 4 19.06 4 18.5V10Z",
    stroke: "#04339D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 8a2 2 0 1 1 4 0 2 2 0 0 1-4 0ZM10 14a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1ZM10 17a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1Z",
    fill: "#C5DEFF"
  })));
};
export default SvgBlogFilled;